module.exports = __webpack_public_path__ + "static/img/air-protd4.2f25a67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/air-protd4.png
// module id = QloU
// module chunks = 1